import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import * as styles from './Progress.module.scss';

type ProgressProps = {
    value: number;
    className?: string | null;
    classes?: Partial<typeof styles>;
};

function Progress({ value, className, classes }: ProgressProps) {
    const percent = `${value}%`;
    const { formatMessage } = useIntl();

    /* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
    /* eslint-disable jsx-a11y/no-redundant-roles */
    return (
        <progress
            className={classNames(styles.root, className, classes?.root)}
            max={100}
            value={value}
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={value}
            aria-label={formatMessage({ id: 'booking.progress.label' })}
        >
            <div className={styles.bar}>
                <span style={{ width: percent }}>Progress: {percent}</span>
            </div>
        </progress>
    );
}

export default Progress;
